@if (data.title) {
<h2 mat-dialog-title>{{ data.title }}</h2>
}

<mat-dialog-content class="dialog-content">
  @if (data.description) {
  <p class="dialog-description">{{ data.description }}</p>
  } @if (preferredPharmacy) {
  <app-alert-box type="info" [label]="'Preferred Pharmacy'" [message]="preferredPharmacy">
  </app-alert-box>
  }

  <mat-form-field class="full-width" appearance="outline">
    <mat-label>Search a Pharmacy</mat-label>
    <input
      matInput
      type="text"
      placeholder="e.g., Medmate"
      [formControl]="locationSearchTerm"
      [matAutocomplete]="auto"
    />
    @if (searching) {
    <mat-spinner matSuffix diameter="20"></mat-spinner>
    } @if (!searching && selectedPharmacy) {
    <button
      matSuffix
      mat-icon-button
      aria-label="Clear"
      matTooltip="Clear"
      (click)="clearSelection()"
    >
      <mat-icon>close</mat-icon>
    </button>
    }
  </mat-form-field>

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selectPharmacy($event.option.value)"
    [displayWith]="displayFn"
  >
    @if ((filteredPharmacies$ | async); as pharmacies) { @for (pharmacy of pharmacies; track
    pharmacy) {
    <mat-option [value]="pharmacy" class="height-auto">
      <div class="option-content">
        <div class="option-title">{{ pharmacy.locationid }} - {{ pharmacy.locationname }}</div>
        <div class="option-subtext">{{ pharmacy.address }}</div>
      </div>
    </mat-option>
    } @if (showCreateNewStoreOption) {
    <mat-option disabled>
      <div class="no-results">
        <strong>No pharmacies found for:</strong>
        <em>"{{ locationSearchTerm.value }}"</em>
      </div>
    </mat-option>
    } @if (showCreateNewStoreOption) {
    <mat-option (onSelectionChange)="redirectToCreateStore()" [value]="null">
      <mat-icon color="primary">open_in_new</mat-icon>
      <strong>Create new store</strong>
    </mat-option>
    } }
  </mat-autocomplete>

  @if (isEmailMissing) {
  <app-alert-box
    type="error"
    [message]="alertMessage"
    ctaLabel="Add Email"
    (ctaClick)="goToStore()"
  >
  </app-alert-box>
  } @if (selectedPharmacy?.email && data.showEmail) {
  <app-alert-box
    type="info"
    label="Selected Pharmacy Email"
    [message]="selectedPharmacy?.email"
  >
  </app-alert-box>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cancel</button>
  <button
    mat-flat-button
    color="accent"
    class="mm-text-white"
    [disabled]="!selectedPharmacy || isEmailMissing"
    (click)="confirmSelection()"
  >
    {{ data?.confirmLabel ?? 'Confirm' }}
  </button>
</mat-dialog-actions>
